// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"9":"fa99eda1","54":"314d83d3","626":"ab3d1749","948":"73e8e1e7"}[chunkId] + ".css";
};